import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';
import 'keen-slider/keen-slider.min.css';

@Component( {
    selector: 'app-keen-slider',
    standalone: true,
    imports: [CommonModule, MatCardModule, MatIconModule],
    templateUrl: './keen-slider.component.html',
    styleUrls: ['./keen-slider.component.scss']
} )
export class KeenSliderComponent implements AfterViewInit, OnDestroy {
    @ViewChild( 'sliderRef' ) sliderRef!: ElementRef<HTMLElement>;
    slider: KeenSliderInstance | null = null;

    @Input() communityData: any[] = []; // src/app/shared/constants

    currentSlide: number = 0;
    dotHelper: Array<Number> = [];

    ngAfterViewInit(): void {
        setTimeout( () => {
            this.slider = new KeenSlider( this.sliderRef.nativeElement, {
                initial: this.currentSlide,
                slideChanged: ( s ) => {
                    this.currentSlide = s.track.details.rel;
                    this.updateDots();
                },
                slides: { perView: 1, spacing: 16 },
                breakpoints: {
                    '(min-width: 600px)': { slides: { perView: 2, spacing: 16 } },
                    '(min-width: 1240px)': { slides: { perView: 3, spacing: 24 } }
                }
            } );

            this.slider.on( 'created', this.updateDots.bind( this ) );
            this.slider.on( 'updated', this.updateDots.bind( this ) );

            this.updateDots(); // Initial dot calculation
        } );
    }

    updateDots(): void {
        if ( !this.slider || !this.slider.track ) return; // Ensure the slider exists

        const totalSlides = this.slider.track.details.slides.length;
        const perView = ( this.slider.options.slides as any ).perView || 1; // Read perView dynamically
        const totalDots = Math.max( 1, totalSlides - perView + 1 ); // Ensure at least 1 dot

        this.dotHelper = [...Array( totalDots ).keys()];
    }

    ngOnDestroy(): void {
        if ( this.slider ) this.slider.destroy();
    }
}
